import React, { useContext, useEffect, useState } from "react";
import './Components/TheStudentDashboard.css';
import EnrolledPaperCompletionGraph from "./Components/EnrolledPaperCompletionGraph";
import PaperCounts from "./Components/PaperCounts";
import CreditsUsage from "./Components/CreditsUsage";
import PaperDetails from "./Components/PaperDetails";
import StudentAnnouncements from "./Components/StudentAnnouncements";
import { MainContext } from "../../../../../context/main/main-context";
import { Alert, LinearProgress, Snackbar } from "@mui/material";
import Boy from "./Components/imageFiles/Boy.png";

const TheStudentDashboard = () => {

  const {
    student_dashboard_initial_loading,
    student_dashboard_data_loading,
    student_dashboard_data,
    fetchStudentDashboardData
  } = useContext(MainContext)

  const [open, setOpen] = useState(false);

  const [userId] = useState(sessionStorage.getItem("manage_user_id"))
  const [userName, setUserName] = useState(sessionStorage.getItem("username"))

  const [availablePaperCount, setAvailablePaperCount] = useState(0);
  const [enrolledPaperCount, setEnrolledPaperCount] = useState(0);
  const [completedPaperCount, setCompletedPaperCount] = useState(0);
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [userCredits, setUserCredits] = useState(null);
  const [availablePapers, setAvailablePapers] = useState([]);
  const [enrolledPapers, setEnrolledPapers] = useState([]);
  const [completedPapers, setCompletedPapers] = useState([]);
  const [allRecentAnnouncements, setAllRecentAnnouncements] = useState([]);
  const [weeklyAnnouncements, setWeeklyAnnouncements] = useState([]);
  const [monthlyAnnouncements, setMonthlyAnnouncements] = useState([]);

  useEffect(() => {
    setOpen(false)
  }, [])

  useEffect(() => {
    if (userId) {
      setOpen(false);
      fetchStudentDashboardData(userId);
    }
  }, [userId]);

  useEffect(() => {

    if (student_dashboard_data && student_dashboard_data.success && student_dashboard_data.data) {

      const data = student_dashboard_data.data;


      setAvailablePaperCount(parseInt(data.available_paper_count) || 0);
      setEnrolledPaperCount(parseInt(data.enrolled_paper_count) || 0);
      setCompletedPaperCount(parseInt(data.completed_paper_count) || 0);
      setCompletionPercentage(parseInt(data.enrolled_paper_completing_level) || 0);
      setUserCredits(data.user_credits || null);
      setAvailablePapers(data.available_papers || []);
      setEnrolledPapers(data.enrolled_papers || []);
      setCompletedPapers(data.completed_papers || []);
      setAllRecentAnnouncements(data.all_recent_announcement || []);
      setWeeklyAnnouncements(data.weekly_announcement || []);
      setMonthlyAnnouncements(data.monthly_announcement || []);

      setOpen(false);

    }
    else if (student_dashboard_data && !student_dashboard_data.success) {
      setOpen(true)
    }
  }, [student_dashboard_data])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };



  return (
    <>
      {student_dashboard_data_loading && !student_dashboard_initial_loading &&
        <LinearProgress color="secondary" />
      }
      <div className="dashboard-container">
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleClose}
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            FAILED TO GET LATEST DASHBOARD DATA
          </Alert>
        </Snackbar>
        <div className="container-fluid px-3 student-dashboard-wrapper">
          {/* Top Grid */}
          <div className="row mb-4">
            {/* Left Side */}
            <div className="col-12 col-md-8">
              <div className="hello mb-3">
                <h3 className="dashboard-header">Hello, {userName || sessionStorage.getItem("username") } <span role="img" aria-label="smile">😊</span></h3>
                <p className="sub-text">Nice to see you! Let’s continue your lessons</p>
              </div>

              <div className="row">
                <div className="col-12 col-md-5 mb-3">
                  <div className="card-box h-100">
                    <EnrolledPaperCompletionGraph
                      completionPercentage={completionPercentage}
                      student_dashboard_initial_loading={student_dashboard_initial_loading}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-7 mb-3">
                  <div className="card-box h-100">
                    <PaperCounts
                      availablePaperCount={availablePaperCount}
                      enrolledPaperCount={enrolledPaperCount}
                      completedPaperCount={completedPaperCount}
                      student_dashboard_initial_loading={student_dashboard_initial_loading}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="col-12 col-md-4">
              <div className="row" style={{ height: '100%' }}>
                <div className="col-12 col-md-8 mb-3 px-0">
                  <div className="card-box h-100">
                    <CreditsUsage
                      userCredits={userCredits}
                      student_dashboard_initial_loading={student_dashboard_initial_loading}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4 d-none d-md-flex align-items-end justify-content-end">
                  <img src={Boy} alt="Boy" className="img-fluid boy-avatar" />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Grid */}
          <div className="row">

            <div className="col-12 col-md-8 paper-col mb-4">
              <div className="card-box">
                <PaperDetails
                  availablePapers={availablePapers}
                  enrolledPapers={enrolledPapers}
                  completedPapers={completedPapers}
                  student_dashboard_initial_loading={student_dashboard_initial_loading}
                />
              </div>
            </div>

            <div className="col-12 col-md-4 announcement-col mb-4">
              <div className="card-box announcement-box">
                <StudentAnnouncements
                  allRecentAnnouncements={allRecentAnnouncements}
                  weeklyAnnouncements={weeklyAnnouncements}
                  monthlyAnnouncements={monthlyAnnouncements}
                  student_dashboard_initial_loading={student_dashboard_initial_loading}
                />
              </div>
           </div>
          </div>

        </div>

      </div>
    </>
  );
};

export default TheStudentDashboard;
